import { useCallback, useRef } from 'react';

type LongPressEvent<E = HTMLElement> = React.MouseEvent<E> | React.TouchEvent<E>;

export function useLongPress<E extends HTMLElement = HTMLElement>(onLongPress: (e: LongPressEvent<E>) => void, delay = 600) {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const start = useCallback(
    (e: LongPressEvent<E>) => {
      if ('button' in e && e.button !== 0) return;

      e.persist?.();

      timerRef.current = setTimeout(() => onLongPress(e), delay);
    },
    [onLongPress, delay],
  );

  const clear = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  return {
    onMouseDown: start,
    onMouseUp: clear,
    onMouseLeave: clear,
    onTouchStart: start,
    onTouchEnd: clear,
  } as const; // щоб React не лаявся на read‑only props
}
